import { ColorV2 } from "config/colors";
import styled from "styled-components";

export const SummaryStrip = styled.div`
  display: flex;
  align-items: stretch;
  gap: 16px;
  padding: 14px 16px;
  border-radius: 20px;
  background: ${ColorV2.White};
  overflow-x: auto;
`;

export const PeriodSlot = styled.div`
  display: flex;
  align-items: center;
  min-width: 250px;
`;

export const StaffHeaderRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 16px;
`;

export const StaffHeaderDateCard = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-radius: 20px;
  background: ${ColorV2.White};
`;

export const StaffHeaderCompanyCardSlot = styled.div`
  display: flex;
  flex: 1;
`;
